module.exports = __webpack_public_path__ + "static/img/activity.7ed5ce7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page_activitycenter/activity.png
// module id = l5tF
// module chunks = 1